export const contact = {
  contactName: "Name",
  favoriteContact: "Favorites",
  contactAction: "Action",
  contactEmail: "Email",
  contactTransfer: "Transfer",
  contactDelete: "Delete",
  contactDeleteMessage: "Are you sure you want to delete this contact?",
  contactEdit: "Edit ",
  contactEditMessage: "Are you sure you want to modify this contact from your favorites list?",
  contactConfirmYes: "Yes",
  contactConfirmNo: "No",
  contactDeleteSuccess: "Contact deleted successfully!",
  contactAddSuccess: "Contact added successfully!",
  contactBackBtn: "Back",
  contactsBtnAdd: "Add",
  contactModalAdd: "Add Contact",
  contactSearch: "Search Contact",
  contactsTableUpdating: "Updating Contacts...",
  contactLoading: "Loading contact information...",
  contactError: "Error fetching contact information. The contact does not exist.",
  contactNotFound: "Contact not found.",
  contactAlreadyInList: "Contact is already in the list.",
  contactAddBtn: "Add",
  contactCancelBtn: "Cancel",
  contactBackBtnText: "Back",
};
